import store from '../store/store';
import { signOut } from '@firebase/auth';
import { firebase } from '../config/firebase.client';
import { ISettingsType, IUserType } from '../types';
import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import {
  EDIT_USER,
  DELETE_USER,
  USER_DELETED,
  FETCH_ALL_USERS,
  EDIT_USER_FAILED,
  FETCH_ALL_DRIVERS,
  EDIT_USER_SUCCESS,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  FETCH_ALL_USERS_STATIC_SUCCESS,
} from "../store/types";

export const fetchUsers = () => (dispatch: any) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });

  const userInfo = store.getState().auth.profile;



  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);

      const locations = locationdata.val();

      let data = snapshot.val();

      const allUsers = Object.keys(data)
        .filter(i => data[i].usertype != 'admin')
        .map(i => {
          data[i].id = i;
          data[i].location = locations && locations[i] ? locations[i] : null;
          return data[i];
        });


      const filteredUsers = userInfo.usertype === 'fleetadmin'
        ? allUsers.filter(user =>
          user.fleetadmin?.includes(userInfo.uid)
        )
        : allUsers;




      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: filteredUsers
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};

export const fetchUsersOnce = () => (dispatch: any) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });


  const userInfo = store.getState().auth.profile;

  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      let data: IUserType[] = snapshot.val();

      const allUsers = Object.keys(data)
        .map((i: any) => {
          data[i].id = i;
          data[i].location = locations && locations[i] ? locations[i] : null;
          return data[i];
        });



      const filteredUsers = userInfo.usertype === 'fleetadmin'
        ? allUsers.filter(user =>
          user.fleetadmin?.includes(userInfo.uid)
        )
        : allUsers;



      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: filteredUsers
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  }, { onlyOnce: true });
};

export const clearFetchDrivers = () => (dispatch: any) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  off(driversRef);
  off(allLocationsRef);
}

export const fetchDrivers = (type: "ALL" | "ACTIVE") => async (dispatch: any) => {

  const {
    driversRef,
    settingsRef,
    allLocationsRef,
  } = firebase;

  const settingsdata = await get(settingsRef);
  const settings: ISettingsType = settingsdata.val();

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });


  try {
    const userInfo = store.getState().auth.profile;

    onValue(driversRef, snapshot => {
      if (snapshot.val()) {
        onValue(allLocationsRef, locres => {
          const locations = locres.val();
          let data = snapshot.val();

          if (userInfo?.usertype === 'fleetadmin') {
            data = Object.keys(data)
              .filter(key => data[key].fleetadmin && data[key].fleetadmin.includes(userInfo.uid))
              .reduce((result: any, key) => {
                result[key] = data[key];
                return result;
              }, {});
          }

          const arr = Object.keys(data).filter(i => {
            const driver: IUserType = data[i];

            if (!locations || !locations[i]) return false;

            if (type == "ACTIVE") {
              if (!driver || !driver.driverActiveStatus) return false;
            }

            if (settings.driver_approval && !driver.approved) return false;

            if (settings.carApproval && !driver.carApproved) return false;

            if (settings.license_image_required && !driver.licenseImage) return false;

            if (settings.term_required && !driver.term) return false;

            return true;
          })
            .map(i => {
              return {
                vehicleNumber: data[i].vehicleNumber ? data[i].vehicleNumber : null,
                location: locations && locations[i] ? locations[i] : null,
                carType: data[i].carType ? data[i].carType : null,
                driverImage: data[i].profile_image,
                firstName: data[i].firstName,
                lastName: data[i].lastName,
                queue: data[i].queue,
                id: i,
              };
            });
          dispatch({
            type: FETCH_ALL_DRIVERS_SUCCESS,
            payload: arr
          });

          return arr;
        }, { onlyOnce: false })
      } else {
        console.error("No users available.")
        dispatch({
          type: FETCH_ALL_DRIVERS_FAILED,
          payload: "No users available."
        });
      }
    }, { onlyOnce: false })
  }
  catch (e) {
    console.error(e)
  }
};

export const addUser = (userdata: IUserType) => (dispatch: any) => {
  const {
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  delete (userdata as any).tableData;

  push(usersRef, userdata).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const editUser = (id: string, user: IUserType) => (dispatch: any) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = user;
  delete editedUser.id;
  delete (editedUser as any).tableData;
  set(singleUserRef(id), editedUser);
}

export const updateUserCar = (id: string, data: Partial<IUserType>) => (dispatch: any) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data
  });
  update(singleUserRef(id), data);
}

export const updateLicenseImage = (uid: string, imageBlob: any, imageType: 'licenseImage' | 'licenseImageBack' | 'verifyIdImage' | 'verifyIdImageSelfie') => async (dispatch: any) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef,
    verifyIdImageSelfieRef
  } = firebase;

  let profile: any;
  if (imageType === 'licenseImage') {
    await uploadBytesResumable(driverDocsRef(uid), imageBlob);
    let image = await getDownloadURL(driverDocsRef(uid));
    profile.licenseImage = image;
  }
  if (imageType === 'licenseImageBack') {
    await uploadBytesResumable(driverDocsRefBack(uid), imageBlob);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    profile.licenseImageBack = image1;
  }
  if (imageType === 'verifyIdImage') {
    await uploadBytesResumable(verifyIdImageRef(uid), imageBlob);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    profile.verifyIdImage = image1;
  }

  if (imageType === 'verifyIdImageSelfie') {
    await uploadBytesResumable(verifyIdImageSelfieRef(uid), imageBlob);
    let image1 = await getDownloadURL(verifyIdImageSelfieRef(uid));
    profile.verifyIdImageSelfie = image1;
  }

  update(singleUserRef(uid), profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};


export const deleteUser = (user: IUserType) => (dispatch: any) => {
  const {
    auth,
    carsRef,
    carEditRef,
    singleUserRef,
    walletHistoryRef,
    userNotificationsRef,
  } = firebase;

  const uid = user.uid || user.id
  if (uid) {
    dispatch({
      type: DELETE_USER,
      payload: uid
    });

    onValue(singleUserRef(uid), userdata => {
      const profile = userdata.val();

      if (!auth.currentUser) return

      if (auth.currentUser.uid === uid) {
        auth.currentUser.delete().then(() => {
          dispatch({
            type: USER_DELETED,
            payload: null
          });
        }).catch((error) => {
          dispatch({
            type: DELETE_USER_FAILED,
            payload: error
          });
        });



        if (profile.usertype !== 'admin') {
          off(singleUserRef(uid));
          off(walletHistoryRef(uid));
          off(userNotificationsRef(uid));
        }
      }

      firebase.callFunction('user-deleteUser', {
        uid,
        appId: user.appId
      });

      if (profile.usertype === 'driver') {

        onValue(carsRef(uid, profile.usertype), carssnapshot => {
          let cars = carssnapshot.val();
          if (cars) {
            const arr = Object.keys(cars);
            for (let i = 0; i < arr.length; i++) {
              remove(carEditRef(arr[i]));
            }
          }
        });
      }

      remove(singleUserRef(uid)).then(() => {
        if (auth?.currentUser?.uid === uid) {
          signOut(auth);
          dispatch({
            type: USER_DELETED,
            payload: null
          });
        } else {
          remove(singleUserRef(uid)).then(() => {
            dispatch({
              type: DELETE_USER_SUCCESS,
              payload: null
            });
          }).catch((error) => {
            dispatch({
              type: DELETE_USER_FAILED,
              payload: error
            });
          });
        }
      });


    }, { onlyOnce: true });
  }
} 